/** 香港金管局持牌銀行（本地註冊 + 境外註冊分行），供司機登記收款戶口選擇 */
const HK_LICENSED_BANK_NAMES_RAW: string[] = [
  // 香港註冊
  '渣打銀行（香港）',
  '香港上海滙豐銀行',
  '中國建設銀行（亞洲）',
  '中國銀行（香港）',
  '東亞銀行',
  '星展銀行（香港）',
  '中信銀行（國際）',
  '招商永隆銀行',
  '恒生銀行',
  '上海商業銀行',
  '大眾銀行（香港）',
  '華僑銀行（香港）',
  '大有銀行',
  '集友銀行',
  '大新銀行',
  '創興銀行',
  '南洋商業銀行',
  '大生銀行',
  '中國工商銀行（亞洲）',
  '富邦銀行（香港）',
  '花旗銀行（香港）',
  '交通銀行（香港）',
  '摩根士丹利銀行（亞洲）',
  '東莞銀行（國際）',
  '眾安銀行',
  '理慧銀行',
  'Mox Bank',
  '匯立銀行',
  '富融銀行',
  '平安數字銀行（國際）',
  '螞蟻銀行（香港）',
  '天星銀行',
  '大象銀行',
  // 境外註冊分行
  '東方匯理銀行',
  '花旗銀行',
  '摩根大通銀行',
  '華僑銀行',
  '交通銀行',
  'UCO銀行',
  '韓亞銀行',
  '三菱日聯銀行',
  '盤谷銀行',
  '印度海外銀行',
  '德意志銀行',
  '美國銀行',
  '法國巴黎銀行',
  '印度銀行',
  '巴基斯坦國民銀行',
  '馬來亞銀行',
  '三井住友銀行',
  '印尼國家銀行',
  '金融銀行',
  '大華銀行',
  '巴克萊銀行',
  '加拿大豐業銀行',
  '加拿大皇家銀行',
  '法國興業銀行',
  '印度國家銀行',
  '多倫多道明銀行',
  '滿地可銀行',
  '加拿大帝國商業銀行',
  '瑞銀集團',
  '瑞穗銀行',
  '德國中央合作銀行',
  '友利銀行',
  '菲律賓國家銀行',
  '三菱日聯信托銀行',
  '紐約梅隆銀行',
  '荷蘭安智銀行',
  '西班牙外換銀行',
  '澳新銀行集團',
  '澳洲聯邦銀行',
  '意大利聯合聖保羅銀行',
  '千葉銀行',
  '比利時聯合銀行',
  '富國銀行',
  '荷蘭合作銀行',
  '星展銀行',
  '靜岡銀行',
  '華南商業銀行',
  '滋賀銀行',
  '臺灣銀行',
  '中國銀行（日本）',
  '第一商業銀行',
  '彰化商業銀行',
  '法國外貿銀行',
  '中國工商銀行',
  '道富銀行和信托公司',
  '中國建設銀行',
  '中國農業銀行',
  '第一儲蓄銀行',
  '中國信託商業銀行',
  '臺灣中小企業銀行',
  '英國滙豐銀行',
  '國泰世華商業銀行',
  '瑞士盈豐銀行',
  '招商銀行',
  '台北富邦商業銀行',
  '永豐商業銀行',
  '兆豐國際商業銀行',
  '玉山商業銀行',
  '台新國際商業銀行',
  '豐隆銀行',
  '渣打銀行',
  '印度工業信貸投資銀行',
  '梅利銀行',
  '華美銀行',
  '遠東國際商業銀行',
  '國泰銀行',
  '臺灣土地銀行',
  '合作金庫商業銀行',
  '桑坦德銀行',
  '上海商業儲蓄銀行',
  '中小企業銀行',
  '新加坡銀行',
  '新韓銀行',
  '王道商業銀行',
  '國家開發銀行',
  '阿布扎比第一銀行',
  '嘉盛銀行',
  'HDFC銀行',
  '瑞聯銀行',
  '瑞典北歐斯安銀行',
  '寶盛銀行',
  '法國工商銀行',
  '臺灣新光商業銀行',
  '中國銀行',
  '東方匯理財富管理',
  '皇家銀行',
  '上海浦東發展銀行',
  '中國民生銀行',
  '廣發銀行',
  '渤海銀行',
  '瑞士百達銀行',
  '東莞銀行',
  '中國光大銀行',
  '聯昌銀行',
  '農協銀行',
  '興業銀行',
  '元大商業銀行',
  '馬士禮格銀行',
  '國民銀行',
  '浙商銀行',
  '平安銀行',
  '華夏銀行',
  '卡塔爾國家銀行',
  '中信銀行',
  '凱基商業銀行',
];

export const HK_LICENSED_BANK_NAMES = [...new Set(HK_LICENSED_BANK_NAMES_RAW)].sort((a, b) =>
  a.localeCompare(b, 'zh-Hant'),
) as readonly string[];

export function isHkLicensedBankName(value: string): boolean {
  return (HK_LICENSED_BANK_NAMES as readonly string[]).includes(value);
}

export function normalizeHongKongBankAccountNumber(raw: string): string {
  return raw.replace(/\s+/g, '').replace(/-/g, '');
}

/** 司機收款戶口：6–20 位數字 */
export function validateHongKongBankAccountNumberField(label: string, raw: string): string | null {
  const n = normalizeHongKongBankAccountNumber(raw);
  if (!n) return `請輸入${label}`;
  if (!/^\d{6,20}$/.test(n)) return `${label}須為 6–20 位數字`;
  return null;
}
